import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Credit } from '../models/credit';

@Injectable({
  providedIn: 'root'
})

export class IdentitySignatureService {

  constructor(private http: HttpClient) { }

  async getSigningMethod(userId: string){
    return this.http.get(environment.identityUrl + "/api/User/" + userId + "/Signature");
  }

  async updateSigningMethod(userId: string, signingMethod: any) {
    return this.http.post(environment.identityUrl + "/api/User/" + userId + "/Signature", signingMethod);
  }
}
